export enum BreakpointsPoints {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl',
  Xs = 'xs',
  Xxl = 'xxl',
  Xxs = 'xxs',
}
